import React from "react";
import { SimpleSelect } from '@instructure/ui-simple-select'
import { Grid } from '@instructure/ui-grid'

class Search extends React.Component {
  constructor (props) {
    super(props)
  }
  render(){
    const { search, searchBy, placeholder, renderDropDown} = this.props
    return (
      <Grid startAt="medium" vAlign="middle" colSpacing="small">
        <Grid.Row>

          <Grid.Col>
            {renderDropDown()}
          </Grid.Col>
        </Grid.Row>
      </Grid>
    )
  }      
}

export default Search;